module.exports = __webpack_public_path__ + "img/biter-attack-1.d91bac67.png";